// 목록 빈 상태 — 메시지 + 등록 CTA + 다음 단계 힌트(사슬 순서: 거래처→제품→수주→생산).
export const LIST_EMPTY = {
  partner: {
    message: '등록된 거래처가 없습니다.',
    ctaLabel: '거래처 등록',
    hint: '거래처를 먼저 등록하면 제품·수주를 연결할 수 있어요. 다음 단계: 제품 등록',
  },
  product: {
    message: '등록된 제품이 없습니다.',
    ctaLabel: '제품 등록',
    hint: '제품을 등록하면 수주에서 선택할 수 있어요. 다음 단계: 수주 등록',
  },
  contract: {
    message: '등록된 수주가 없습니다.',
    ctaLabel: '수주 등록',
    hint: '수주를 등록하면 생산 실적을 입력할 수 있어요. 다음 단계: 생산 등록',
  },
};
